<rap-producers-ui [producers]="producers" (createProducerEmitter)="createProducers()"
    (editProducerEmitter)="editProducers($event)" (deleteProducerEmitter)="deleteProducers($event)"
    (searchProducerEmitter)="searchProducer($event)"></rap-producers-ui>